import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.66 24.21">
    <defs />
    <title>Quote Matks</title>
    <path
      fill={`#d6434f`}
      d="M13.66,18.42a5.78,5.78,0,0,1-.82,3.08,5.46,5.46,0,0,1-2.2,2,6.43,6.43,0,0,1-2.91.7,7.2,7.2,0,0,1-5.26-2.64C.82,19.81,0,17.35,0,14.17A13.84,13.84,0,0,1,3.42,4.69Q6.86.8,13.15,0V3.37A14.36,14.36,0,0,0,6.57,6.21a6.52,6.52,0,0,0-2.51,5.25q0,1.8,1.29,1.8a17.94,17.94,0,0,1,3-.37A5.2,5.2,0,0,1,12,14.46,5.28,5.28,0,0,1,13.66,18.42Z"
    />
    <path
      fill={`#d6434f`}
      d="M30.66,18.42a5.78,5.78,0,0,1-.82,3.08,5.46,5.46,0,0,1-2.2,2,6.43,6.43,0,0,1-2.91.7,7.2,7.2,0,0,1-5.26-2.64C17.82,19.81,17,17.35,17,14.17a13.84,13.84,0,0,1,3.42-9.48Q23.86.8,30.15,0V3.37a14.36,14.36,0,0,0-6.58,2.84,6.52,6.52,0,0,0-2.51,5.25q0,1.8,1.29,1.8a17.94,17.94,0,0,1,3-.37A5.2,5.2,0,0,1,29,14.46,5.28,5.28,0,0,1,30.66,18.42Z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/tour/assets/QuotationMark_Red.js